export default {
  currentViewMode() {
    const { viewMode } = this
    return this.videModeOptions.find((x) => x.value === viewMode)
  },
  isStandardMode: (state) => state.viewMode === 'standard',
  // 是否处于 All multiples 视图（即 System）
  isAllMultiplesMode: (state) => state.viewMode === 'allMultiples',
  singleStakeList: (state) => Object.values(state.singleStakeMap)
}
